import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-genstore/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-genstore/update-status',
    method: 'put',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-genstore/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-genstore/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-genstore/update',
    method: 'put',
    data: data
  })
}

export function getMasterGenstoreList() {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-genstore/common-list',
    method: 'get'
  })
}






// WEBPACK FOOTER //
// ./src/api/master_genstore.js